import axios from "axios";

const BASE = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BASE}/api`;

export const TOKEN_KEY = "durga_session_token";

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};
export const setToken = (t) => {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch {}
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
